<template>
  <div v-if="lists.length > 0">
    <el-card shadow="never">
      <div class="input_wrap">
        <el-row :gutter="20">
          <el-col
            :span="3"
            v-for="(items, index) in lists"
            :key="index"
            :class="lists.length >= 8 ? 'input_box margin_bottom' : 'input_box'"
          >
            <!--文本-->
            <template v-if="items.style == 'text'">
              <el-input
                :placeholder="items.displayName"
                v-model="searchData[items.fieldName]"
                size="mini"
                class="input"
                style="width: 100%"
              ></el-input>
            </template>

            <!--狀態-->
            <template v-if="items.style == 'status'">
              <cc-constant-selector
                :placeholder="items.displayName"
                valType="String"
                style="width: 100%"
                v-model="searchData[items.fieldName]"
                :code="items.dataSource"
                api="admin/dict/pageTree"
                :clearable="items.clearable"
              />
            </template>

            <!--遠程數據-->
            <template v-if="items.style == 'selector'">
              <cc-selector
                :config="items.selectorConfig"
                v-model="searchData[items.fieldName]"
                :value="items.selectorConfig.valType"
                :placeholder="$t('customSearch.tipSelect') + items.displayName"
              />
            </template>

            <template v-if="items.style == 'select'">
              <el-select
                style="width: 100%"
                v-model="searchData[items.fieldName]"
                :placeholder="$t('customSearch.tipSelect') + items.displayName"
                size="mini"
                clearable
                :multiple="items.multiple ? items.multiple : false"
                :filterable="items.filterable ? items.filterable : false"
                collapse-tags
              >
                <el-option
                  v-for="item in items.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>

            <!-- <template v-if="items.style == 'selectMultiple'">
              <el-select
                v-model="searchData[items.fieldName]"
                :placeholder="'請選擇' + items.displayName"
                size="mini"
                clearable
                multiple 
              >
                <el-option
                  v-for="item in items.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template> -->

            <!--時間-->
            <template v-if="items.style == 'time'">
              <el-date-picker
                type="datetime"
                size="mini"
                style="width: 100%"
                v-model="searchData[items.fieldName]"
                :value-format="
                  items.valueFormat ? items.valueFormat : 'yyyy-MM-dd HH:mm:ss'
                "
                :placeholder="items.displayName"
                :default-time="
                  items.defaultTime ? items.defaultTime : '00:00:00'
                "
              ></el-date-picker>
            </template>

            <template v-if="items.style == 'date'">
              <el-date-picker
                type="date"
                size="mini"
                style="width: 100%"
                v-model="searchData[items.fieldName]"
                :value-format="
                  items.valueFormat ? items.valueFormat : 'yyyy-MM-dd'
                "
                :placeholder="items.displayName"
              ></el-date-picker>
            </template>
            <template v-if="items.style == 'month'">
              <el-date-picker
                type="month"
                size="mini"
                style="width: 100%"
                v-model="searchData[items.fieldName]"
                :value-format="
                  items.valueFormat ? items.valueFormat : 'yyyy-MM'
                "
                :placeholder="items.displayName"
              ></el-date-picker>
            </template>
          </el-col>
          <el-col :span="1" class="search_wrap">
            <el-button
              icon="el-icon-search"
              size="mini"
              class="search"
              type="primary"
              @click="doSearch"
              >{{ $t("customSearch.searchBtn") }}</el-button
            >
            <slot name="button" />
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>
<script>
// 表格搜索模塊 extend from cc-search
export default {
  name: "CustomSearch",
  props: {
    config: {
      type: Array,
      required: true,
    },
    //配置示例
    //       searchConfig: [
    //     {
    //       displayName: "ID", //顯示名
    //       fieldName: "id",//字段名
    //       style: "text", //樣式  status time text
    //       value: "1" // 默認值
    //     },
    //     {
    //       displayName: "活动名称", //顯示名
    //       fieldName: "activityName",//字段名
    //       style: "text" //樣式  status time text
    //       //   value: "1"
    //     },
    //     {
    //       displayName: "活动狀態", //顯示名
    //       fieldName: "status",//字段名
    //       dataSource: "status",
    //       style: "status" //樣式  status time text
    //       valueFormat:"timestamp"  //時間格式
    //       //   value: "0"
    //     },
    //      {
    //      displayName: "所有門店",
    //      fieldName: "shopId",
    //      style: "selector",
    //      selectorConfig: {
    //        api: "admin/sp/shop/query?pageSize=999&isAsc=true",
    //        valProp: "id",
    //        labelProp: "name",
    //        width: "100%",
    //        valueType: "string"
    //      }
    //   ]
  },
  i18n: {
    messages: {
      en: {
        customSearch: {
          searchBtn: "Search",
        },
      },
      zh: {
        customSearch: {
          searchBtn: "搜索",
        },
      },
    },
  },
  data() {
    return {
      lists: [],
      searchData: {},
    };
  },
  methods: {
    doSearch() {
      let obj = {};
      for (const key in this.searchData) {
        if (this.searchData[key]) {
          obj[key] = this.searchData[key];
        }
      }
      this.$emit("doSearch", obj);
    },
  },
  watch: {
    config: {
      handler() {
        this.lists = JSON.parse(JSON.stringify(this.config));
        let dateObj = {};
        for (let i = 0; i < this.lists.length; i++) {
          if (this.lists[i].value) {
            dateObj[this.lists[i].fieldName] = this.lists[i].value;
          }
        }
        this.$set(this, "searchData", dateObj);
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
};
</script>
<style scoped>
.input_box {
  max-width: 300px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.search_wrap {
  display: flex;
}
.search {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
}
</style>
